import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Stack} from "@mui/material";
import Divider from "@mui/material/Divider";
import {useTranslation} from "react-i18next";

export const ReleaseNote = ({releaseNote}) => {
    const {t} = useTranslation("dams.document", {useSuspense: false});
    const {title, description, updatedAt} = releaseNote;
    return (
        <Box sx={{marginBottom: '16px'}}>
            <Typography variant="h6">{t('version', 'Versjon')} {title}</Typography>
            <Typography variant="body2">
                <span dangerouslySetInnerHTML={{__html: description}}/>
            </Typography>
            <Stack direction="row" sx={{
                justifyContent: "flex-end"
            }}>
                <Typography variant="caption">
                    {
                        new Date(updatedAt).toLocaleDateString('no-NO', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                        })
                    }
                </Typography>
            </Stack>
            <Divider orientation="horizontal" sx={{marginTop: '8px'}}/>
        </Box>
    );
};